import React from "react";
import { Page, Document, Image, StyleSheet, View } from "@react-pdf/renderer";
import InvoiceTitle from "./InvoiceTitle";
import BillTo from "./BillTo";
import InvoiceItemsTable from "./InvoiceItemsTable";
import SmartBuildItemsTable from "./SmartBuildItemsTable";

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 15,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 74,
    height: 66,
    marginLeft: "auto",
    marginRight: "auto",
  },
  section: {
    marginTop: 20,
  },
});

const Invoice = ({ data, user }) => {
  console.log("data", data);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <InvoiceTitle title="Purchase Order" />
        <BillTo values={data} user={user} />

        {data.metalOrder && data.metalOrder.length > 0 && (
          <View style={styles.section}>
            <InvoiceItemsTable values={data} />
          </View>
        )}

        {data.customPackage && data.customPackage.items && data.customPackage.items.length > 0 && (
          <View style={styles.section}>
            <SmartBuildItemsTable items={data.customPackage.items} />
          </View>
        )}
      </Page>
    </Document>
  );
};

export default Invoice;
